import { render, staticRenderFns } from "./EquityChange.vue?vue&type=template&id=64fe485e&scoped=true&"
import script from "./EquityChange.vue?vue&type=script&lang=js&"
export * from "./EquityChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe485e",
  null
  
)

export default component.exports